import React, { Suspense, lazy } from 'react';
import { StickyAlert } from './components/sections/StickyAlert';
import { Hero } from './components/sections/Hero';
import { ProblemSection } from './components/sections/ProblemSection';
// Lazy load below-the-fold sections for better performance
const SalesLetter = lazy(() => import('./components/sections/SalesLetter').then(m => ({
  default: m.SalesLetter
})));
const Stats = lazy(() => import('./components/sections/Stats').then(m => ({
  default: m.Stats
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Bonuses = lazy(() => import('./components/sections/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(m => ({
  default: m.Pricing
})));
const Upsell = lazy(() => import('./components/sections/Upsell').then(m => ({
  default: m.Upsell
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/sections/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  return <div className="min-h-screen font-sans text-gray-900 selection:bg-gold selection:text-forest-green" data-id="element-0">
      <StickyAlert data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <Suspense fallback={<div className="min-h-[200px]" data-id="element-6" />} data-id="element-5">
          <SalesLetter data-id="element-7" />
          <Stats data-id="element-8" />
          <Testimonials data-id="element-9" />
          <Bonuses data-id="element-10" />
          <Pricing data-id="element-11" />
          <Upsell data-id="element-12" />
          <Guarantee data-id="element-13" />
          <FAQ data-id="element-14" />
        </Suspense>
      </main>
      <Suspense fallback={<div className="min-h-[100px]" data-id="element-16" />} data-id="element-15">
        <Footer data-id="element-17" />
      </Suspense>
    </div>;
}